import { createContext, useContext } from 'react'
import type { AmbitoId } from '../data/ambitiStats'

export const AmbitoSelectionContext = createContext<AmbitoId | null | undefined>(undefined)

export function useAmbitoSelection(): AmbitoId | null | undefined {
  return useContext(AmbitoSelectionContext)
}
